/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9348b4de (Tue Jan 13 18:25:19 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  CreatePlaylistItemsRequestBody,
  CreatePlaylistItemsRequestBodyToJSON,
  CreatePlaylistRequestBody,
  CreatePlaylistRequestBodyToJSON,
  CreatePlaylistResponse,
  CreatePlaylistResponseFromJSON,
  FetchPlaylistResponse,
  FetchPlaylistResponseFromJSON,
  FetchUserPlaylistsResponse,
  FetchUserPlaylistsResponseFromJSON,
  UpdatePlaylistItemsOrderRequestBody,
  UpdatePlaylistItemsOrderRequestBodyToJSON,
  UpdatePlaylistNameRequestBody,
  UpdatePlaylistNameRequestBodyToJSON,
  UpdatePlaylistNameResponse,
  UpdatePlaylistNameResponseFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface CreatePlaylistRequest extends runtime.BaseRequestParameters {
  body: CreatePlaylistRequestBody
}

export interface CreatePlaylistItemsRequest
  extends runtime.BaseRequestParameters {
  body: CreatePlaylistItemsRequestBody
}

export interface DeletePlaylistRequest extends runtime.BaseRequestParameters {
  playlistKey: number
}

export interface DeletePlaylistItemRequest
  extends runtime.BaseRequestParameters {
  playlistItemKey: number
}

export interface FetchPlaylistRequest extends runtime.BaseRequestParameters {
  playlistKey: number
}

export interface FetchUserPlaylistsRequest
  extends runtime.BaseRequestParameters {
  playlistType?: FetchUserPlaylistsPlaylistTypeEnum
}

export interface UpdatePlaylistItemsOrderRequest
  extends runtime.BaseRequestParameters {
  playlistKey: number
  body: UpdatePlaylistItemsOrderRequestBody
}

export interface UpdatePlaylistNameRequest
  extends runtime.BaseRequestParameters {
  playlistKey: number
  body: UpdatePlaylistNameRequestBody
}

/**
 * PlaylistsApi - interface
 *
 * @export
 * @interface PlaylistsApiInterface
 */
export interface PlaylistsApiInterface {
  /**
   * Creates a new playlist associated to the authenticated user and their actorKey. Requires a name and playlistType.      If an widenAssetKey is provided, the playlist will include an initial item. Each user can have up to 20 playlists in total, regardless of playlistType.
   * @summary Add a new playlist.
   * @param {CreatePlaylistRequestBody} createPlaylistRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaylistsApiInterface
   */
  createPlaylistRaw(
    requestParameters: CreatePlaylistRequest
  ): Promise<runtime.ApiResponse<CreatePlaylistResponse>>

  /**
   * Creates a new playlist associated to the authenticated user and their actorKey. Requires a name and playlistType.      If an widenAssetKey is provided, the playlist will include an initial item. Each user can have up to 20 playlists in total, regardless of playlistType.
   * Add a new playlist.
   */
  createPlaylist(
    requestParameters: CreatePlaylistRequest
  ): Promise<CreatePlaylistResponse>

  /**
   * Adds multiple assets to a playlist by providing a single \"playlistKey\" and an array of \"widenAssetKeys\".   The assets are added in the order provided, and their positions are automatically assigned to follow any existing items in the playlist.   The total number of items in a playlist must not exceed 100.
   * @summary Adds one or more items to the specified playlist. Each item includes a reference to a widenAsset and its position within the playlist.
   * @param {CreatePlaylistItemsRequestBody} createPlaylistItemsRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaylistsApiInterface
   */
  createPlaylistItemsRaw(
    requestParameters: CreatePlaylistItemsRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Adds multiple assets to a playlist by providing a single \"playlistKey\" and an array of \"widenAssetKeys\".   The assets are added in the order provided, and their positions are automatically assigned to follow any existing items in the playlist.   The total number of items in a playlist must not exceed 100.
   * Adds one or more items to the specified playlist. Each item includes a reference to a widenAsset and its position within the playlist.
   */
  createPlaylistItems(
    requestParameters: CreatePlaylistItemsRequest
  ): Promise<void>

  /**
   * Deletes a playlist by its unique \'playlistKey\',      along with all associated playlist items.      The endpoint first verifies that the playlist exists.      If it does not, an error is returned with an informative message.      Upon successful deletion, both the playlist and any related items are permanently removed.       Only the owner of the playlist is authorized to delete it.
   * @summary Delete an existing playlist by its key
   * @param {number} playlistKey Unique identifier of the playlist to delete.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaylistsApiInterface
   */
  deletePlaylistRaw(
    requestParameters: DeletePlaylistRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Deletes a playlist by its unique \'playlistKey\',      along with all associated playlist items.      The endpoint first verifies that the playlist exists.      If it does not, an error is returned with an informative message.      Upon successful deletion, both the playlist and any related items are permanently removed.       Only the owner of the playlist is authorized to delete it.
   * Delete an existing playlist by its key
   */
  deletePlaylist(requestParameters: DeletePlaylistRequest): Promise<void>

  /**
   * Deletes a playlistItem by its unique \'playlistItemKey\',   The endpoint first verifies that the playlistItem exits.   If it does not, an error is returned with an informative message.   Upon successful deletion, the playlistItem record is permanently removed.   Only the owner of the playlistItem is authorized to delete it.
   * @summary Delete an existing playlistItem by its key
   * @param {number} playlistItemKey Unique identifier of the playlistItem to delete.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaylistsApiInterface
   */
  deletePlaylistItemRaw(
    requestParameters: DeletePlaylistItemRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Deletes a playlistItem by its unique \'playlistItemKey\',   The endpoint first verifies that the playlistItem exits.   If it does not, an error is returned with an informative message.   Upon successful deletion, the playlistItem record is permanently removed.   Only the owner of the playlistItem is authorized to delete it.
   * Delete an existing playlistItem by its key
   */
  deletePlaylistItem(
    requestParameters: DeletePlaylistItemRequest
  ): Promise<void>

  /**
   * Returns the details of a playlist by playlistKey (name, actorKey, userKey, playlistType, playlistItems)    as well as the playlist items belonging to the specified playlistKey.
   * @summary Fetch playlist details and items by playlistKey
   * @param {number} playlistKey The unique identifier for the playlist to fetch.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaylistsApiInterface
   */
  fetchPlaylistRaw(
    requestParameters: FetchPlaylistRequest
  ): Promise<runtime.ApiResponse<FetchPlaylistResponse>>

  /**
   * Returns the details of a playlist by playlistKey (name, actorKey, userKey, playlistType, playlistItems)    as well as the playlist items belonging to the specified playlistKey.
   * Fetch playlist details and items by playlistKey
   */
  fetchPlaylist(
    requestParameters: FetchPlaylistRequest
  ): Promise<FetchPlaylistResponse>

  /**
   * Returns all playlists created by the authenticated user, optionally filtered by playlistType.   If playlistType is not specified, all playlists are returned. The response includes a total count of   playlists, which includes BC/LC playlists already created.
   * @summary Fetch all playlists for a user
   * @param {'LearningCenter' | 'BusinessCenter'} [playlistType] Query parameters for fetching user playlists, it could be learning center or business center.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaylistsApiInterface
   */
  fetchUserPlaylistsRaw(
    requestParameters: FetchUserPlaylistsRequest
  ): Promise<runtime.ApiResponse<FetchUserPlaylistsResponse>>

  /**
   * Returns all playlists created by the authenticated user, optionally filtered by playlistType.   If playlistType is not specified, all playlists are returned. The response includes a total count of   playlists, which includes BC/LC playlists already created.
   * Fetch all playlists for a user
   */
  fetchUserPlaylists(
    requestParameters: FetchUserPlaylistsRequest
  ): Promise<FetchUserPlaylistsResponse>

  /**
   * Allows users to update the order of existing items in a playlist by providing a new ordered list of widenAssetKeys.
   * @summary Update the order of items in a playlist
   * @param {number} playlistKey Unique identifier of the playlist whose items order is being updated.
   * @param {UpdatePlaylistItemsOrderRequestBody} updatePlaylistItemsOrderRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaylistsApiInterface
   */
  updatePlaylistItemsOrderRaw(
    requestParameters: UpdatePlaylistItemsOrderRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Allows users to update the order of existing items in a playlist by providing a new ordered list of widenAssetKeys.
   * Update the order of items in a playlist
   */
  updatePlaylistItemsOrder(
    requestParameters: UpdatePlaylistItemsOrderRequest
  ): Promise<void>

  /**
   * Allows users to rename an existing playlist. A new name must be provided in the request.
   * @summary Update the name of an existing playlist
   * @param {number} playlistKey The id of the playlist.
   * @param {UpdatePlaylistNameRequestBody} updatePlaylistNameRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaylistsApiInterface
   */
  updatePlaylistNameRaw(
    requestParameters: UpdatePlaylistNameRequest
  ): Promise<runtime.ApiResponse<UpdatePlaylistNameResponse>>

  /**
   * Allows users to rename an existing playlist. A new name must be provided in the request.
   * Update the name of an existing playlist
   */
  updatePlaylistName(
    requestParameters: UpdatePlaylistNameRequest
  ): Promise<UpdatePlaylistNameResponse>
}

/**
 *
 */
export class PlaylistsApi
  extends runtime.BaseAPI
  implements PlaylistsApiInterface
{
  /**
   * Creates a new playlist associated to the authenticated user and their actorKey. Requires a name and playlistType.      If an widenAssetKey is provided, the playlist will include an initial item. Each user can have up to 20 playlists in total, regardless of playlistType.
   * Add a new playlist.
   */
  async createPlaylistRaw(
    requestParameters: CreatePlaylistRequest
  ): Promise<runtime.ApiResponse<CreatePlaylistResponse>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling createPlaylist.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/playlist`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: CreatePlaylistRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreatePlaylistResponseFromJSON(jsonValue)
    )
  }

  /**
   * Creates a new playlist associated to the authenticated user and their actorKey. Requires a name and playlistType.      If an widenAssetKey is provided, the playlist will include an initial item. Each user can have up to 20 playlists in total, regardless of playlistType.
   * Add a new playlist.
   */
  async createPlaylist(
    requestParameters: CreatePlaylistRequest
  ): Promise<CreatePlaylistResponse> {
    const response = await this.createPlaylistRaw(requestParameters)
    return await response.value()
  }

  /**
   * Adds multiple assets to a playlist by providing a single \"playlistKey\" and an array of \"widenAssetKeys\".   The assets are added in the order provided, and their positions are automatically assigned to follow any existing items in the playlist.   The total number of items in a playlist must not exceed 100.
   * Adds one or more items to the specified playlist. Each item includes a reference to a widenAsset and its position within the playlist.
   */
  async createPlaylistItemsRaw(
    requestParameters: CreatePlaylistItemsRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling createPlaylistItems.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/playlist/items`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: CreatePlaylistItemsRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Adds multiple assets to a playlist by providing a single \"playlistKey\" and an array of \"widenAssetKeys\".   The assets are added in the order provided, and their positions are automatically assigned to follow any existing items in the playlist.   The total number of items in a playlist must not exceed 100.
   * Adds one or more items to the specified playlist. Each item includes a reference to a widenAsset and its position within the playlist.
   */
  async createPlaylistItems(
    requestParameters: CreatePlaylistItemsRequest
  ): Promise<void> {
    await this.createPlaylistItemsRaw(requestParameters)
  }

  /**
   * Deletes a playlist by its unique \'playlistKey\',      along with all associated playlist items.      The endpoint first verifies that the playlist exists.      If it does not, an error is returned with an informative message.      Upon successful deletion, both the playlist and any related items are permanently removed.       Only the owner of the playlist is authorized to delete it.
   * Delete an existing playlist by its key
   */
  async deletePlaylistRaw(
    requestParameters: DeletePlaylistRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.playlistKey === null ||
      requestParameters.playlistKey === undefined
    ) {
      throw new runtime.RequiredError(
        'playlistKey',
        'Required parameter requestParameters.playlistKey was null or undefined when calling deletePlaylist.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/playlist/{playlistKey}`.replace(
        `{${'playlistKey'}}`,
        encodeURIComponent(String(requestParameters.playlistKey))
      ),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Deletes a playlist by its unique \'playlistKey\',      along with all associated playlist items.      The endpoint first verifies that the playlist exists.      If it does not, an error is returned with an informative message.      Upon successful deletion, both the playlist and any related items are permanently removed.       Only the owner of the playlist is authorized to delete it.
   * Delete an existing playlist by its key
   */
  async deletePlaylist(
    requestParameters: DeletePlaylistRequest
  ): Promise<void> {
    await this.deletePlaylistRaw(requestParameters)
  }

  /**
   * Deletes a playlistItem by its unique \'playlistItemKey\',   The endpoint first verifies that the playlistItem exits.   If it does not, an error is returned with an informative message.   Upon successful deletion, the playlistItem record is permanently removed.   Only the owner of the playlistItem is authorized to delete it.
   * Delete an existing playlistItem by its key
   */
  async deletePlaylistItemRaw(
    requestParameters: DeletePlaylistItemRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.playlistItemKey === null ||
      requestParameters.playlistItemKey === undefined
    ) {
      throw new runtime.RequiredError(
        'playlistItemKey',
        'Required parameter requestParameters.playlistItemKey was null or undefined when calling deletePlaylistItem.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/playlistItem/{playlistItemKey}`.replace(
        `{${'playlistItemKey'}}`,
        encodeURIComponent(String(requestParameters.playlistItemKey))
      ),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Deletes a playlistItem by its unique \'playlistItemKey\',   The endpoint first verifies that the playlistItem exits.   If it does not, an error is returned with an informative message.   Upon successful deletion, the playlistItem record is permanently removed.   Only the owner of the playlistItem is authorized to delete it.
   * Delete an existing playlistItem by its key
   */
  async deletePlaylistItem(
    requestParameters: DeletePlaylistItemRequest
  ): Promise<void> {
    await this.deletePlaylistItemRaw(requestParameters)
  }

  /**
   * Returns the details of a playlist by playlistKey (name, actorKey, userKey, playlistType, playlistItems)    as well as the playlist items belonging to the specified playlistKey.
   * Fetch playlist details and items by playlistKey
   */
  async fetchPlaylistRaw(
    requestParameters: FetchPlaylistRequest
  ): Promise<runtime.ApiResponse<FetchPlaylistResponse>> {
    if (
      requestParameters.playlistKey === null ||
      requestParameters.playlistKey === undefined
    ) {
      throw new runtime.RequiredError(
        'playlistKey',
        'Required parameter requestParameters.playlistKey was null or undefined when calling fetchPlaylist.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/playlists/{playlistKey}`.replace(
        `{${'playlistKey'}}`,
        encodeURIComponent(String(requestParameters.playlistKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchPlaylistResponseFromJSON(jsonValue)
    )
  }

  /**
   * Returns the details of a playlist by playlistKey (name, actorKey, userKey, playlistType, playlistItems)    as well as the playlist items belonging to the specified playlistKey.
   * Fetch playlist details and items by playlistKey
   */
  async fetchPlaylist(
    requestParameters: FetchPlaylistRequest
  ): Promise<FetchPlaylistResponse> {
    const response = await this.fetchPlaylistRaw(requestParameters)
    return await response.value()
  }

  /**
   * Returns all playlists created by the authenticated user, optionally filtered by playlistType.   If playlistType is not specified, all playlists are returned. The response includes a total count of   playlists, which includes BC/LC playlists already created.
   * Fetch all playlists for a user
   */
  async fetchUserPlaylistsRaw(
    requestParameters: FetchUserPlaylistsRequest
  ): Promise<runtime.ApiResponse<FetchUserPlaylistsResponse>> {
    const queryParameters: any = {}

    if (requestParameters.playlistType !== undefined) {
      queryParameters['playlistType'] = requestParameters.playlistType
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/playlists`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchUserPlaylistsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Returns all playlists created by the authenticated user, optionally filtered by playlistType.   If playlistType is not specified, all playlists are returned. The response includes a total count of   playlists, which includes BC/LC playlists already created.
   * Fetch all playlists for a user
   */
  async fetchUserPlaylists(
    requestParameters?: FetchUserPlaylistsRequest
  ): Promise<FetchUserPlaylistsResponse> {
    const response = await this.fetchUserPlaylistsRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * Allows users to update the order of existing items in a playlist by providing a new ordered list of widenAssetKeys.
   * Update the order of items in a playlist
   */
  async updatePlaylistItemsOrderRaw(
    requestParameters: UpdatePlaylistItemsOrderRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.playlistKey === null ||
      requestParameters.playlistKey === undefined
    ) {
      throw new runtime.RequiredError(
        'playlistKey',
        'Required parameter requestParameters.playlistKey was null or undefined when calling updatePlaylistItemsOrder.'
      )
    }

    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling updatePlaylistItemsOrder.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/playlist/{playlistKey}/order-items`.replace(
        `{${'playlistKey'}}`,
        encodeURIComponent(String(requestParameters.playlistKey))
      ),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: UpdatePlaylistItemsOrderRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Allows users to update the order of existing items in a playlist by providing a new ordered list of widenAssetKeys.
   * Update the order of items in a playlist
   */
  async updatePlaylistItemsOrder(
    requestParameters: UpdatePlaylistItemsOrderRequest
  ): Promise<void> {
    await this.updatePlaylistItemsOrderRaw(requestParameters)
  }

  /**
   * Allows users to rename an existing playlist. A new name must be provided in the request.
   * Update the name of an existing playlist
   */
  async updatePlaylistNameRaw(
    requestParameters: UpdatePlaylistNameRequest
  ): Promise<runtime.ApiResponse<UpdatePlaylistNameResponse>> {
    if (
      requestParameters.playlistKey === null ||
      requestParameters.playlistKey === undefined
    ) {
      throw new runtime.RequiredError(
        'playlistKey',
        'Required parameter requestParameters.playlistKey was null or undefined when calling updatePlaylistName.'
      )
    }

    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling updatePlaylistName.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/playlist/{playlistKey}`.replace(
        `{${'playlistKey'}}`,
        encodeURIComponent(String(requestParameters.playlistKey))
      ),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: UpdatePlaylistNameRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UpdatePlaylistNameResponseFromJSON(jsonValue)
    )
  }

  /**
   * Allows users to rename an existing playlist. A new name must be provided in the request.
   * Update the name of an existing playlist
   */
  async updatePlaylistName(
    requestParameters: UpdatePlaylistNameRequest
  ): Promise<UpdatePlaylistNameResponse> {
    const response = await this.updatePlaylistNameRaw(requestParameters)
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum FetchUserPlaylistsPlaylistTypeEnum {
  LearningCenter = 'LearningCenter',
  BusinessCenter = 'BusinessCenter',
}
